// Modal.js

import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SourceDto } from "../../../Types/ApiTypes";
// import i18n from "../../i18n";
import { addSource, putSource, deleteSource } from "../../../Utils/LocalApi";

interface SourceModalEditProps{
    source: SourceDto,
    updateSource: (source: SourceDto)=> void,
    deleteSource: (id?: number)=> void,
    closeModal: ()=> void
}

const SourceModalEdit = (props: SourceModalEditProps) => {
    // const [id, setId] = useState(props.source.id?? null);
    const [code, setCode] = useState(props.source.code);
    const [name, setName] = useState(props.source.name);
    const [year, setYear] = useState(props.source.year?? 0)
    const backgroundaRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();


    return (
        <>{<div className="modal fs-5" tabIndex={-1} style={{display: "block"}}>
            <div 
                ref={backgroundaRef}
                className="modal-background"
                tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" 
                onClick={e=>{
                    if(e.target === backgroundaRef.current)
                    {
                        props.closeModal(); 
                    }
                }}>
                <div className="modal-dialog" style={{maxWidth: "75%"}}>
                    <form className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                {props.source.id && <span>{t("sourcelist-id")}: {props.source.id}</span>}
                            </h4>
                            <button type="button" className="btn-close" onClick={e=>{props.closeModal();}} aria-label="Close"></button>
                        </div>
                        <div className="d-flex flex-wrap text-center">
                            <div className="d-flex col-6 p-2">
                                <span className="col-3">{t("sourcelist-code")}</span>
                                <span className="col-9">
                                    <input 
                                        value={code}
                                        type="text"
                                        className="form-control"
                                        name="code"
                                        onChange={(e) => {
                                            setCode(e.target.value)
                                        }}
                                    ></input>
                                </span>
                            </div>
                            <div className="d-flex col-6 p-2">
                                <span className="col-3">{t("sourcelist-year")}</span>
                                <span className="col-9">
                                    <input 
                                            value={year}
                                            type="number"
                                            className="form-control"
                                            name="year"
                                            onChange={(e) => {
                                                setYear(parseInt(e.target.value))
                                            }}
                                        ></input>
                                </span>
                            </div>
                            <div className="d-flex col-6 p-2">
                                <span className="col-3">{t("sourcelist-name")} en</span>
                                <span className="col-9">
                                    <input 
                                        value={name.en}
                                        type="text"
                                        className="form-control"
                                        name="name-en"
                                        onChange={(e) => {
                                            setName({...name, "en": e.target.value})
                                        }}
                                    ></input>
                                </span>
                            </div>
                            <div className="d-flex col-6 p-2">
                                <span className="col-3">{t("sourcelist-name")} it</span>
                                <span className="col-9">
                                    <input 
                                        value={name.it}
                                        type="text"
                                        className="form-control"
                                        name="name-en"
                                        onChange={(e) => {
                                            setName({...name, "it": e.target.value})
                                        }}
                                    ></input>
                                </span>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <span><button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={e=>{modalDelete()}}>{t("modal-delete")}</button></span>
                            <span>
                                <button type="button" className="btn btn-secondary m-1" data-bs-dismiss="modal" onClick={e=>{props.closeModal();}}>{t("modal-close")}</button>
                                <button type="button" className="btn btn-primary m-1" onClick={modalSave}>{t("modal-save")}</button>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>}</>
    )

    function modalDelete(){
        let id = props.source.id;
        if (id){
            deleteSource(id).then((result) => {
                if (result >= 200 && result < 300){
                    props.deleteSource(id);
                    props.closeModal();
                }
            })
        }
        else{
            props.closeModal();
        }
    }

    function modalSave(){
        if (props.source.id){
            putSource({
                id: props.source.id,
                code: code,
                name: name,
                year: year
            }).then((source) => {
                props.updateSource(source);
                props.closeModal();
            })
        }else{
            addSource({
                code: code,
                name: name,
                year: year
            }).then((source) => {
                props.updateSource(source);
                props.closeModal();
            })
        }
      
    }  
}
export default SourceModalEdit;